import React from "react";

import {DeleteActionColumn, NameCol, SellAllBody, SRRICol} from "./table-data";
import {PriceColumn} from "../shared/modelPortfolioTableColumns";
import {
  LimitOrderColumnNew, NumberOfSharesColumnNew, OrderAmountColumn,
  ShareSettingsColumn
} from "../../../../../RiskProfiling/components/StepContent/components/step/ProductsSelectionSteps/components/InvestmentRecommendationStep/components/Portfolio/table-data";
import {withEuroOrDash} from "../../../../../../utils/utils";
import {makeStyles} from "@material-ui/core";
import {getTotal} from "../../../ExAnteStep/components/ExAnteStepV2/utils";

const InternalNameCol = {...NameCol, colSpan: {footer: 5}}

export const AmountCol = {
  ...OrderAmountColumn,
  footer: [({items}) => withEuroOrDash(getTotal(items, (i) => i.transaction_value))],
  cellClassName: 'amount-cell',
}

const TradeLimit = {...LimitOrderColumnNew, cellClassName: 'with-input amount-cell'}
const TradeNumberOfSharesColumnNew = {...NumberOfSharesColumnNew, cellClassName: 'with-input amount-cell'}
const TradeShareSettingsColumn = {...ShareSettingsColumn, cellClassName: 'with-input einzeltitel-settings-cell'}
const TradePriceColumn = {...PriceColumn, footer: undefined}

export const tableStructureForEinzeltitelBuyTrading = [
  InternalNameCol,
  SRRICol,
  TradePriceColumn,
  TradeShareSettingsColumn,
  TradeLimit,
  TradeNumberOfSharesColumnNew,
  AmountCol,
  DeleteActionColumn
]

const useSellAllStyles = makeStyles((theme) => ({
  radio: {
    padding: 2
  }
}))

const SellAllCol = {
  header: [() => 'Alles verkaufen'],
  body: [({item, options}) => {
    const classes = useSellAllStyles();
    return <SellAllBody item={item} options={options} customClasses={classes} fieldToCheck={'quantity'} fieldToCompare={'quantity'} />
  }],
  footer: [() => null],
  cellClassName: 'with-input sell-all-cell'
}

export const tableStructureForEinzeltitelSellTrading = [
  InternalNameCol,
  SRRICol,
  TradePriceColumn,
  TradeShareSettingsColumn,
  TradeLimit,
  TradeNumberOfSharesColumnNew,
  SellAllCol,
  AmountCol,
  DeleteActionColumn
]